export namespace CircleImageConsts {
  export const defaultSize = '50px';
}
